import React, {useState} from 'react';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';

export default function JobStatusToggleGroup({radioValue, setRadioValue, statusCounts}) {
    const radios = [
        {name: 'Pending', value: 'Pending', variant: 'outline-dark'},
        {name: 'Important', value: 'Updated', variant: 'outline-danger'},
        {name: 'Scheduled', value: 'Scheduled', variant: 'outline-primary'},
        {name: 'InProgress', value: 'InProgress', variant: 'outline-warning'},
        {name: 'ReadyForBilling', value: 'ReadyForBilling', variant: 'outline-success'},
        {name: 'Cancelled', value: 'Cancelled', variant: 'outline-secondary'},
        {name: 'X', value: 'ALL', variant: 'outline-dark'},

    ];

    return (
        <>
            <ButtonGroup>
                {radios.map((radio, idx) => (
                    <ToggleButton

                        key={idx}
                        id={`jobstatusradio-${idx}`}
                        type="radio"
                        variant={radio.variant}
                        name="radio"
                        value={radio.value}
                        checked={radioValue === radio.value}
                        onChange={(e) => setRadioValue(e.currentTarget.value)}
                    >
                        {radio.name === 'Important' && statusCounts['Updated'] ? 
                            radio.name + ' (' + statusCounts['Updated'] + ') ' :
                            statusCounts[radio.name] ? radio.name + ' (' + statusCounts[radio.name] + ') ' :
                            radio.name + '    '}
                    </ToggleButton>
                ))}
            </ButtonGroup>
        </>
    );
}
